import { render, staticRenderFns } from "./wikimore.vue?vue&type=template&id=41905c1a&scoped=true"
import script from "./wikimore.vue?vue&type=script&lang=js"
export * from "./wikimore.vue?vue&type=script&lang=js"
import style0 from "./wikimore.vue?vue&type=style&index=0&id=41905c1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41905c1a",
  null
  
)

export default component.exports